import BaseContainer from "@components/ui/BaseContainer";
import clsx from "clsx";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { useTranslation } from "react-i18next";
import classes from "./Development.module.scss";

const Development = () => {
  const { t } = useTranslation();

  const list: { title: string; text: string; img: string }[] = t("development.list", { returnObjects: true });

  return (
    <BaseContainer className={classes.development}>
      <ul className={classes.development__list}>
        {list.map((item, index) => (
          <li key={item.title} className={clsx(classes.development__item, classes.item)}>
            <img
              className={classes.item__img}
              src={require(`@assets/images/main/development/${item.img}.png`)}
              alt=""
            />

            <AnimationOnScroll className={classes.item__info} animateIn="animate__fadeInUp" delay={100} animateOnce>
              <h2 className={classes.item__title}>{item.title}</h2>
              <p className={classes.item__text}>{item.text}</p>
            </AnimationOnScroll>
          </li>
        ))}
      </ul>
    </BaseContainer>
  );
};

export default Development;
